import { Steps } from "antd";
import { Form, Formik } from "formik";
import { flatten, map, pathOr, values } from "ramda";
import React, { useEffect, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import CustomLabel from "../../../../components/customLabel";
import { Switch, Tooltip } from "antd";

import Checkbox from "antd/lib/checkbox/Checkbox";
import BottomBar from "../../../../components/bottomBar";
import CommonFields from "../../../../components/commonFields";
import ConfirmPopup from "../../../../components/confirmPopup";
import CustomButton from "../../../../components/customButton";
import LoadingSpinner from "../../../../components/loadingSpinner";
import CustomNotification from "../../../../components/notification";
import UploadFile from "../../../../components/uploadFile";
import {
  broadCastEmployeeListAction,
  broadCastMessageAction,
  broadCastMessageReviewAction,
  removeBroadCastEmployeeAction,
  uploadBroadCastCommaSeparatedValuesAction,
  uploadBroadCastFileNewAction,
} from "../../../../sagas/saga-broadcast";
import BroadcastMessage from "../BroadcastMessage/BroadcastMessage";
import SaveFile from "../saveFile/index";
import SelectFile from "../selectFile/index";

import NoInternetAction from "../../../../actions/noInternetAction";
import { setPopup } from "../../../../actions/popupAction";
import { ErrorYellowIcon, MultiLanguageInfoIcon } from "../../../../assets/svg";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import {
  MOBILE_WIDTH,
  NEXTGEN_EHR_WHITELABEL,
  newLineRegex,
} from "../../../../constants/constants";
import { getFormData } from "../../../../helper/helpers";
import BroadcastService from "../../../../service/BroadcastUserService";
import loginService from "../../../../service/login";
import { directTextInputValidation, fileUploadOptions } from "../../constants";
import InitiateBroadcast from "../InitiateBroadcast/initiateBroadcast";
import { DebouncedDirectTextInput } from "../deboundedDirectTextInput/debouncedDirectTextInput";
import MobileHeader from "../../../../components/header/mobileHeader";
import "./styles.scss";
const IS_NON_PROD = !process.env.REACT_APP_ENV?.endsWith("prod"); 

const { Step } = Steps;

const getFlattenedSelected = (selectionState) =>
  flatten(values(selectionState.selected || {}));

const getSelectedCount = (selectionState, filteredCount) =>
  selectionState.allSelected
    ? filteredCount - selectionState.unselected.length
    : getFlattenedSelected(selectionState).length;

const EmployeeBroadcast = (props) => {
  const dispatch = useDispatch();
  const broadcastService = new BroadcastService();
  const steps = [
    {
      title: "First",
      content: "",
    },
    {
      title: "Second",
      content: "",
    },
    {
      title: "Last",
      content: "Last-content",
    },
  ];
  const [current, setCurrent] = useState(0);
  const { width } = useWindowDimensions();
  const next = () => {
    if (current === 1) {
      if (state.selectionState.allSelected) {
        setCurrent(current + 1);
      } else {
        const selectedIds = getFlattenedSelected(state.selectionState);
        if (selectedIds.length > 0) {
          setCurrent(current + 1);
        } else {
          dispatch(
            setPopup({
              customPopupMessage: true,
              messageType: "error",
              message: "Please select atleast one contact",
            })
          );
        }
      }
    } else {
      setCurrent(current + 1);
    }
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const selectFileRef = useRef();
  const { editDeleteAccess, handleEmailTemplateData } = props;

  const handleNextButton = (values) => {
    if (current === 0 && isCommaSeparatedValues) {
      return handleCommaSeparatedValuesUpload(values);
    } else if (current === 0) {
      setCurrent(1);
      selectFileRef.current.handleFileSave(state.file);
    }
  };
  const handleTwilioDisabledToggle = (checked) => {
  try {
    localStorage.setItem("isTwilioDisabled_employee", String(checked));
  } catch (e) {
    console.log(e);
  }
  setState((st) => ({ ...st, isTwilioDisabled: checked }));
};
const handleAllowDuplicateToggle = (checked) => {
  try {
    localStorage.setItem("allowDuplicate_employee", String(checked));
  } catch (e) {
    console.log(e);
  }
  setState((st) => ({ ...st, allowDuplicate: checked }));
};
  const handlePreview = (preview) => {
    setState((st) => ({
      ...st,
      preview,
    }));
  };
  const [state, setState] = useState({
    file: undefined,
    fileUploaded: false,
    isFiltered: false,
    filterText: "",
    filterData: [],
    selected: [],
    data: [],
    headers: [],
    modal: false,
    loading: true,
    showtable: false,
    broadcastIds: null,
    message: "",
    reviewMsg: "",
    filename: "",
    fileId: "",
    customFileId: "",
    convoType: "",
    errorMessage: null,
    confirmPopup: false,
    broadcastInitiated: false,
    delimiter: "pipe",
    searchKey: "",
    searchValue: "",
    selectionState: {
      selected: {},
      unselected: [],
      allSelected: false,
    },
    saveFileLayout: false,
    customFileName: "",
    saveFile: false,
    fileNameError: "",
    selectFile: false,
    useCustomFile: "",
    preview: false,
    isDirectTextInput: false,
    isTwilioDisabled: localStorage.getItem("isTwilioDisabled_employee") === "true",
    allowDuplicate: localStorage.getItem("allowDuplicate_employee") === "true",
  });
  const { isDirectTextInput } = state;
  useEffect(
    () => {
      if (state.fileUploaded && !state.broadcastInitiated) {
        setCurrent(1);
      }
    },
    [state.fileUploaded, state.broadcastInitiated]
  );
  const handleMobFileSelect = (file) => {
    setState((st) => ({
      ...st,
      file,
    }));
  };
  const fetchEmployeeData = () => {
    try {
      props.broadCastEmployeeList({}, (status, response) => {
        const { data, count } = response || {};

        if (status && data && data.length) {
          const headers = JSON.parse(data[0].headers);

          const fields = data.map((item) => ({
            id: item.id,
            ...JSON.parse(item.fields),
          }));

          setState((st) => ({
            ...st,
            isFiltered: false,
            fileUploaded: true,
            headers,
            data: fields,
            showtable: true,
            filename: data[0] ? data[0].fileName : "",
            fileId: data[0] ? data[0].fileId : "",
            customFileId: data?.[0]?.customFileId || "",
            loading: false,
            count,
            errorMessage: null,
            isDirectTextInput: data[0]?.fileName?.length ? false : true,
             isTwilioDisabled:
              localStorage.getItem("isTwilioDisabled_employee") === "true",
          }));
        } else {
          setState((st) => ({
            ...st,
            fileUploaded: false,
            loading: false,
            saveFile: false,
            customFileName: "",
             isTwilioDisabled: localStorage.getItem("isTwilioDisabled_employee") === "true",
          }));
        }
      });
    } catch (e) {
      setState((st) => ({
        ...st,
        loading: false,
      }));
    }
  };

  // TODO: Remove in future if not reverted
  const getEmployeeSendAnotherMsg = async (fileId) => {
    try {
      // await broadcastService.getEmployeeList(fileId);
      // await broadcastService.updateUnsentRecords(fileId);
    } catch (e) {
      props.setPopup({
        customPopupMessage: true,
        message: "Something went wrong, please try again",
        messageType: "error",
      });
    }
  };

  // upload file
  const handleFileUpload = () => {
    const checkConnection = window.navigator.onLine ? "on" : "off";
    if (checkConnection === "off") {
      setState((st) => ({
        ...st,
        ...{
          fileUploaded: false,
          loading: false,
          confirmPopup: false,
        },
      }));
      setCurrent(0);
      props.setPopup({
        customPopupMessage: true,
        message: "You are offline, Please check your internet connection",
        messageType: "error",
      });
    } else {
      setState((st) => ({
        ...st,
        loading: true,
        confirmPopup: false,
      }));

      const { delimiter, saveFile, file, customFileName } = state;
      const formData = new FormData();
      formData.append("userType", "employee");
      formData.append("delimiter", delimiter);
      formData.append("saveFile", saveFile);
      formData.append("fileNickName", customFileName);
      formData.append("file", file);
      formData.append("allowDuplicate", state.allowDuplicate);
      props.uploadBroadCastFile(formData, (status, data) => {
        if (status) {
          setState((st) => ({
            ...st,
            loading: true,
            fileUploaded: true,
            headers: data.headers,
            errorMessage: null,
          }));
          setCurrent(1);
          fetchEmployeeData();
        } else {
          if (!state.saveFile) {
            setCurrent(0);
            props.setPopup({
              customPopupMessage: true,
              message: data,
              messageType: "error",
            });

            setState((st) => ({
              ...st,
              errorMessage: "No employee record found or file limit exceeds",
              loading: false,
            }));
          } else {
            setState((st) => ({
              ...st,
              fileNameError: data,
              loading: false,
            }));
          }
        }
      });
    }
  };
  const handleCommaSeparatedValuesUpload = (values) => {
    setState((st) => ({ ...st, loading: true, confirmPopup: false }));
    const updatedValues = values.commaSeparatedText?.replace(newLineRegex, "");
    const payload = {
      userType: "employee",
      values: updatedValues,
      allowDuplicate: state.allowDuplicate,
    };
    props.uploadBroadCastCommaSeparatedValues(payload, (status, data) => {
      if (status) {
        setState((st) => ({
          ...st,
          loading: true,
          fileUploaded: true,
          headers: data.headers,
          errorMessage: null,
        }));
        setCurrent(1);
        fetchEmployeeData();
      } else {
        if (!state.saveFile) {
          setCurrent(0);
          props.setPopup({
            customPopupMessage: true,
            message: data,
            messageType: "error",
          });

          setState((st) => ({
            ...st,
            errorMessage: "Unable to add values through direct input.",
            loading: false,
          }));
        } else {
          setState((st) => ({
            ...st,
            fileNameError: data,
            loading: false,
          }));
        }
      }
    });
  };

  const submit = (formValues) => {
    props.noInternetAction();

    if (!props.noInternet.noInternetMessage) {
      const selected = getFlattenedSelected(state.selectionState);
      const selectedCount = getSelectedCount(
        state.selectionState,
        state.filteredCount
      );
      if (selectedCount > 0) {
        setState((st) => ({
          ...st,
          modal: true,
          selected,
          message: formValues,
        }));

        broadcastMessage(selected, formValues);
      } else {
        props.setPopup({
          customPopupMessage: true,
          message: "Please select at least one contact.",
          messageType: "error",
        });
      }
    } else {
      props.setPopup({
        customPopupMessage: true,
        message: props.noInternet.noInternetMessage,
        messageType: "error",
      });
    }
  };

  const broadcastMessage = (selected, message) => {
    const selectedCount = getSelectedCount(
      state.selectionState,
      state.filteredCount
    );
    if (!selectedCount) {
      props.setPopup({
        customPopupMessage: true,
        message: "Please select at least one contact.",
        messageType: "error",
      });
      return;
    }

    setState((st) => ({
      ...st,
      loading: true,
    }));
    const practiceId = loginService.getPracticeId();
    let data = {
      practiceId,
      filename: state.filename,
      customFileId: state.customFileId,
      message: message,
      broadcastIds: selected,
      userType: "employee",
      fileId: state.fileId,
      allowDuplicate: state.allowDuplicate,
      convoType: message.convoType,
      emailSubject: message.emailSubject,
      emailColumn: message.emailColumn,
      emailTemplateId: message.emailTemplateId,
      ivrMessage: message.ivrMessage,
      ivrTemplate: message.ivrTemplate,
      useSmsForIVR: message.useSmsForIVR,
      optOutMessage: message.optOutMessage,
      optOutTemplate: message.optOutTemplate,
      enableOptOut: message.enableOptOut,
      responseTemplate: message.responseTemplate,
      responseMessage: message.responseMessage,
      selectAll: state.selectionState.allSelected,
      selectedCount,
      filter: state.searchValue,
      unselectedIds: state.selectionState.unselected,
      subtype:
        message.convoType === "ivr" && message.subtype ? "audio" : "text",
      isTwilioDisabled: IS_NON_PROD 
       ? state.isTwilioDisabled  
       : localStorage.getItem("isTwilioDisabled_employee") === "true",
      countryCodeForRcs: localStorage.getItem("countryCodeForRcs") || "",
    };

    const payloadData = {
      body: JSON.stringify(data),
      audio: message.audio,
    };

    const formData = getFormData(payloadData);

    try {
      props.broadCastMessage(formData, async (status, msg) => {
        props.setPopup({
          customPopupMessage: true,
          message: "Broadcast has been queued please check report for status",
          messageType: "success",
        });

        if (status) {
          props.setPopup({
            customPopupMessage: true,
            message: "Message broadcast successfully",
            messageType: "success",
          });

          await getEmployeeSendAnotherMsg(data.fileId);

          setState((st) => ({
            ...st,
            loading: false,
            errorMessage: null,
            broadcastInitiated: true,
            selectionState: {
              selected: {},
              unselected: [],
              allSelected: false,
            },
          }));
        } else {
          setState((st) => ({ ...st, loading: false }));

          props.setPopup({
            customPopupMessage: true,
            message: msg,
            messageType: "error",
          });
        }
      });
    } catch (e) {
      setState((st) => ({
        ...st,
        loading: false,
      }));

      props.setPopup({
        customPopupMessage: true,
        message: "Something went wrong",
        messageType: "error",
      });
    }
  };

  const cancel = () => {
    setState((st) => ({ ...st, loading: true }));

    try {
      props.removeBroadCastEmployee({ fileId: state.fileId }, (status) => {
        if (status) {
          setState((st) => ({
            ...st,
            file: undefined,
            fileUploaded: false,
            filterText: "",
            filterKey: "",
            filterData: [],
            selected: [],
            headers: [],
            data: [],
            loading: false,
            showtable: false,
            selectionState: {
              selected: {},
              allSelected: false,
              unselected: [],
            },
            delimiter: "pipe",
            saveFile: false,
            saveFileLayout: false,
            customFileName: "",
            selectFile: false,
            useCustomFile: "",
          }));
          setCurrent(0);
        }
      });
    } catch (err) {
      setState((st) => ({ ...st, loading: false }));
    }
  };

  const handleResend = async () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: false,
      loading: true,
      file: undefined,
      showtable: false,
      saveFile: false,
      selectFile: false,
      saveFileLayout: false,
      customFileName: "",
    }));
    if (width < MOBILE_WIDTH) {
      props.handleBackButton();
    } else {
      fetchEmployeeData();
    }
  };

  const handleResetFileData = () => {
    setState((st) => ({
      ...st,
      file: [],
      isReset: true,
      errorMessage: "",
      saveFileLayout: false,
    }));
  };

  const setFile = (value, error, sizeErr, saveFileLayout) => {
    setState((st) => ({
      ...st,
      file: value[0] && value[0].originFileObj,
      errorMessage: sizeErr,
      saveFileLayout: saveFileLayout,
    }));
  };

  const hideInitiateBroadcast = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: false,
    }));
  };

  const fetchTableData = (filters) => {
    return new Promise((resolve, reject) => {
      const { order: sortBy, search, page, ...others } = filters;
      const filter = search ? encodeURIComponent(JSON.stringify(search)) : "";
      const filterChanged = state.searchValue !== filter;

      setState((st) => ({
        ...st,
        searchKey: search && Object.keys(search)[0],
        searchValue: search && JSON.stringify(search),
        pageNo: page,
        ...(filterChanged
          ? {
              selectionState: {
                allSelected: false,
                selected: {},
                unselected: [],
              },
            }
          : {}),
      }));

      props.broadCastEmployeeList(
        { ...others, filter, sortBy, page },
        (status, response) => {
          const { data, count } = response || {};
          if (status && data && data.length) {
            const fields = data.map((item) => ({
              id: item.id,
              ...JSON.parse(item.fields),
            }));
            if (
              state.selectionState.allSelected &&
              !pathOr(false, ["selected", page], state.selectionState)
            ) {
              setState((st) => ({
                ...st,
                selectionState: {
                  ...st.selectionState,
                  selected: {
                    ...pathOr({}, ["selectionState", "selected"], st),
                    [page]: map(rowKey, fields),
                  },
                },
              }));
            }

            setState((st) => ({
              ...st,
              fields,
              filteredCount: count,
              isDirectTextInput: data[0]?.fileName?.length ? false : true,
            }));

            resolve({ rows: fields, count });
          }
          resolve({ rows: [], count: 0 });
        }
      );
    });
  };

  const getScheduledMsgData = (message) => {
    const selected = getFlattenedSelected(state.selectionState);

    let data = {
      broadcastIds: selected,
      message: message,
      userType: "employee",
      fileId: state.fileId,
      selectAll:
       state.selectionState.allSelected,
      selectedCount: getSelectedCount(state.selectionState, state.filteredCount),
      filter: state.searchValue,
      unselectedIds: state.selectionState.unselected,
    };

    return data;
  };

  const getSuggestions = async (column, value) => {
    try {
      const data = await broadcastService.getSuggestionsEmployee(column, value);
      return data || [];
    } catch (e) {
      return [];
    }
  };

  const rowKey = (row) =>
    row["id"] || row[pathOr("CellPhone", [0, "accessor"], state.headers)];

  const showBroadcastResend = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: true,
      loading: false,
      selectionState: {
        selected: {},
        unselected: [],
        allSelected: false,
      },
    }));
  };

  const getSavedFileContent = async () => {
    setState((st) => ({ ...st, loading: true }));
    try {
      const { useCustomFile } = state;
      const content = await broadcastService.getSavedFileContent(
        useCustomFile,
        "employee"
      );

      const { data, count } = content || {};

      if (data && data.length) {
        const headers = JSON.parse(data[0].headers);

        const fields = data.map((item) => ({
          id: item.id,
          ...JSON.parse(item.fields),
        }));

        setState((st) => ({
          ...st,
          fileUploaded: true,
          data: fields,
          filename: data[0] ? data[0].fileName : "",
          fileId: data[0] ? data[0].fileId : "",
          customFileId: data?.[0]?.customFileId || "",
          showtable: true,
          headers,
          loading: false,
          count,
          useCustomFile: "",
        }));
      }
    } catch (err) {
      setState((st) => ({ ...st, loading: false }));
    }
  };

  const handleParentLoading = (loading = true) => {
    setState((st) => ({
      ...st,
      loading,
    }));
  };

  const handleTypeChange = (e) => {
    setState((st) => {
      return {
        ...st,
        delimiter: e.target.value,
      };
    });
    handleBack();
  };

  const resetFileNameErr = () => {
    setState((st) => ({
      ...st,
      fileNameError: "",
    }));
  };

  const getCustomeFileName = (val) => {
    setState((st) => ({
      ...st,
      customFileName: val,
      saveFile: true,
      fileNameError: "",
    }));
    showConfirmPopup();
  };

  const showConfirmPopup = () => {
    setState((st) => ({
      ...st,
      confirmPopup: true,
    }));
  };

  const hideConfirmPopup = () => {
    setState((st) => ({
      ...st,
      confirmPopup: false,
      saveFile: false,
      customFileName: "",
    }));
  };

  const handleBack = () => {
    setState((st) => ({
      ...st,
      file: undefined,
      saveFileLayout: false,
      isReset: true,
      saveFile: false,
      customFileName: "",
      fileNameError: "",
      selectFile: false,
    }));
  };

  const handleRecentUploads = () => {
    setState((st) => ({
      ...st,
      selectFile: true,
    }));
  };

  const handleUseCustomFile = (file) => {
    setState((st) => ({
      ...st,
      useCustomFile: file.fileNickName,
    }));
  };

  const handleLoading = (flg) => {
    setState((st) => ({
      ...st,
      loading: flg,
    }));
  };

  const backButtonClicked = () => {
    switch (current) {
      case 0:
        props.handleBackButton();
        return;
      case 1:
        cancel();
        return;
      case 2:
        if (!state.broadcastInitiated) {
          prev();
        } else {
          props.handleBackButton();
        }
        return;
      case 3:
        prev();
        return;
      default:
        return;
    }
  };

  const getDisabledState = (isValid) => {
    if (current === 0 && isCommaSeparatedValues) {
      return !isValid;
    } else if (current === 0) {
      return state.file && state.file.customFileId ? false : true;
    } else if (current === 1) {
      return true;
    }
  };

  useEffect(
    () => {
      setState((st) => ({
        ...st,
        file: undefined,
        isReset: false,
        errorMessage: null,
      }));
    },
    [state.delimiter, state.selectFile]
  );

  useEffect(
    () => {
      if (state.useCustomFile !== "") {
        getSavedFileContent();
      }
    },
    [state.useCustomFile]
  );

  useEffect(() => {
    fetchEmployeeData();
  }, []);

  const {
    fileUploaded,
    data,
    loading,
    headers,
    filename,
    confirmPopup,
    errorMessage,
    count,
    showtable,
    selectionState,
    selectFile,
    fileId,
    customFileId,
  } = state;
  const isCommaSeparatedValues = state.delimiter === "commaSeparatedValues";

  const { customPopupMessage, messageType, message } = props.popupReducer;
  const selectedRows = getFlattenedSelected(selectionState);

  return (
    <Formik
      validateOnMount
      validateOnChange={false}
      validate={(values) => {
        const errors = {};

        if (Boolean(directTextInputValidation(values)?.length)) {
          errors.commaSeparatedText = directTextInputValidation(values);
        }
        return errors;
      }}
      initialValues={{ messageType: "sms", commaSeparatedText: "" }}
      onSubmit={(values, actions) => {
        handleCommaSeparatedValuesUpload(values);
      }}
    >
      {({
        values,
        setFieldValue,
        touched,
        errors,
        isValid,
        dirty,
        validateForm,
        setFieldTouched,
      }) => {
        return (
          <>
            {!state.preview && (
              <>
                <div className="header-bar-mob">
                  <MobileHeader
                    showLogo={false}
                    showNotifications={false}
                    showHelp={false}
                    showAccountDetails={false}
                    showBackButton={true}
                    showPageTitle={true}
                    pageTitle="New Broadcast"
                    handleBackButton={backButtonClicked}
                    backgroundColor={NEXTGEN_EHR_WHITELABEL ? "black-bg" : ""}
                  />

                  <div className="stepper">
                    <Steps
                      current={current}
                      direction="horizontal"
                      responsive={false}
                      size="small"
                    >
                      {steps.map((item) => (
                        <Step key={item.title} />
                      ))}
                    </Steps>
                  </div>
                </div>
              </>
            )}
            {customPopupMessage && (
              <CustomNotification messageType={messageType} message={message} />
            )}

            <div className="employee-main-container">
              {confirmPopup && (
                <ConfirmPopup
                  titleMessage={
                    state.saveFile
                      ? "Confirm to save & upload"
                      : "Confirm to upload"
                  }
                  handleCancel={hideConfirmPopup}
                  handleDelete={handleFileUpload}
                  isVisible={confirmPopup}
                  submitButtonText="Yes"
                  cancelButtonText="No"
                  message={
                    state.saveFile
                      ? "Are you sure you want to save & upload this file?"
                      : "Are you sure you want to upload this file without saving it for future use?"
                  }
                />
              )}
              <If condition={errorMessage}>
                <Then>
                  <section className="no-appointments-message">
                    <span className="message">
                      {ErrorYellowIcon} {errorMessage}
                    </span>
                  </section>
                </Then>
              </If>

              <If condition={loading}>
                <Then>
                  <div className="hide-for-mob">
                    {" "}
                    <LoadingSpinner customClassName="broadcast" />
                  </div>
                  <div className="display-in-mob">
                    {" "}
                    <LoadingSpinner customClassName="broadcast" type="large" />
                  </div>
                </Then>
              </If>

              <If condition={state.broadcastInitiated}>
                <Then>
                  <InitiateBroadcast
                    heading="Broadcast Initiated"
                    hideMessage={hideInitiateBroadcast}
                    handleResend={handleResend}
                    history={props.history}
                  />
                </Then>
              </If>

              <If condition={fileUploaded && !state.broadcastInitiated}>
                <Then>
                  <BroadcastMessage
                    isDirectTextInput={isDirectTextInput}
                    loading={loading}
                    headers={headers}
                    data={data}
                    showTable={showtable}
                    fileName={filename}
                    customFileId={customFileId}
                    fileId={fileId}
                    broadcastMessage={submit}
                    onCancel={cancel}
                    showCheckboxes
                    typeLabel="Employees"
                    onSelectAllChange={(selectAll) => {
                      setState((st) => ({ ...st, selectAll }));
                    }}
                    fetchTableData={fetchTableData}
                    getSuggestions={getSuggestions}
                    showBroadcastResend={showBroadcastResend}
                    handleParentLoading={handleParentLoading}
                    count={count}
                    rowSelection={{
                      columnTitle: (() => {
                        const { allSelected, unselected } = selectionState;
                        const allRowsSelected =
                          allSelected && unselected.length === 0;

                        const someRowsSelected =
                          !allRowsSelected && selectedRows.length > 0;
                        return (
                          <Checkbox
                            disabled={loading}
                            checked={allRowsSelected}
                            onChange={() => {
                              setState((st) => {
                                if (st.selectionState.allSelected) {
                                  return {
                                    ...st,
                                    selectionState: {
                                      allSelected: false,
                                      selected: {},
                                      unselected: [],
                                    },
                                  };
                                }

                                return {
                                  ...st,
                                  selectionState: {
                                    allSelected: true,
                                    unselected: [],
                                    selected: {
                                      ...st.selectionState.selected,
                                      [st.pageNo]: (st.fields || []).map(
                                        rowKey
                                      ),
                                    },
                                  },
                                };
                              });
                            }}
                            indeterminate={someRowsSelected}
                          />
                        );
                      })(),
                      selectedRowKeys: selectedRows,
                      renderCell: (_checked, record, index) => {
                        const checked = selectedRows.includes(rowKey(record));
                        return (
                          <Checkbox
                            checked={checked}
                            onChange={(e) => {
                              setState((st) => {
                                const key = rowKey(record);
                                const flatSelected = getFlattenedSelected(
                                  st.selectionState
                                );
                                const alreadyChecked =
                                  flatSelected.includes(key);

                                if (!alreadyChecked) {
                                  const newSelected = {
                                    ...st.selectionState.selected,
                                    [st.pageNo]: [
                                      ...(st.selectionState.selected[
                                        st.pageNo
                                      ] || []),
                                      key,
                                    ],
                                  };
                                  const flatAfterAdd = getFlattenedSelected({
                                    ...st.selectionState,
                                    selected: newSelected,
                                  });

                                  return {
                                    ...st,
                                    selectionState: {
                                      allSelected:
                                        st.selectionState.allSelected ||
                                        flatAfterAdd.length === st.count,
                                      selected: newSelected,
                                      unselected:
                                        st.selectionState.unselected.filter(
                                          (x) => x !== key
                                        ),
                                    },
                                  };
                                }

                                const newPageSelected = (
                                  st.selectionState.selected[st.pageNo] || []
                                ).filter((x) => x !== key);
                                const newSelected = {
                                  ...st.selectionState.selected,
                                  [st.pageNo]: newPageSelected,
                                };
                                const newUnselected = st.selectionState
                                  .allSelected
                                  ? [...st.selectionState.unselected, key]
                                  : [];

                                return {
                                  ...st,
                                  selectionState: {
                                    allSelected: st.selectionState.allSelected
                                      ? newUnselected.length !== st.count
                                      : false,
                                    selected: newSelected,
                                    unselected: newUnselected,
                                  },
                                };
                              });
                            }}
                          />
                        );
                      },
                      type: "checkbox",
                    }}
                    getScheduledMsgData={getScheduledMsgData}
                    getEmployeeSendAnotherMsg={getEmployeeSendAnotherMsg}
                    current={current}
                    nextPage={next}
                    prevPage={prev}
                    handleEmailTemplateData={handleEmailTemplateData}
                  />
                </Then>
                <Else>{null}</Else>
              </If>

              <If condition={!fileUploaded && !selectFile}>
                <Then>
                  <div className="broadcast-upload-container">
                    <div
                      className={`upload-section-container ${
                        state.delimiter === "commaSeparatedValues"
                          ? "no-upload-button"
                          : ""
                      }`}
                    >
                      {!state.preview && (
                        <h2 className="upload-section-header">
                          Upload employee file for broadcast message
                        </h2>
                      )}
                      {!state.preview && (
                        <p className="upload-section-info">
                          <strong>Note:</strong>{" "}
                          {isCommaSeparatedValues
                            ? "You can add maximum 50 Phone Numbers."
                            : "File should not exceed more than 8mb and 80k rows!"}
                        </p>
                      )}
                      <div className={state.preview ? "" : `radio-container`}>
                        {!state.preview && (
                          <CommonFields
                            name="delimiter"
                            type={"radio"}
                            value={state.delimiter}
                            defaultValue={"pipe"}
                            options={fileUploadOptions}
                            handleChange={handleTypeChange}
                          />
                        )}

                        <div className="display-in-mob">
                          <section>
                            {!state.saveFileLayout ? (
                              <>
                                {!state.preview &&
                                  state.delimiter !==
                                    "commaSeparatedValues" && (
                                    <UploadFile
                                      setFileData={setFile}
                                      name="file"
                                      handleRemove={handleResetFileData}
                                      isReset={state.isReset}
                                      fileFormat={
                                        state.delimiter === "comma"
                                          ? ["txt", "csv"]
                                          : "txt"
                                      }
                                      delimiter={state.delimiter}
                                    />
                                  )}
                              </>
                            ) : (
                              <div className="save-container-mob">
                                <div>
                                  <SaveFile
                                    showConfirmPopup={showConfirmPopup}
                                    getCustomeFileName={getCustomeFileName}
                                    file={state.file}
                                    responseError={state.fileNameError}
                                    resetFileNameErr={resetFileNameErr}
                                  />
                                </div>
                                <div style={{ textAlign: "end" }}>
                                  <CustomButton
                                    btntype="clear"
                                    title="Back"
                                    className="back-button"
                                    onClick={handleBack}
                                  />
                                </div>
                              </div>
                            )}
                          </section>
                        </div>
                      </div>
                    {  IS_NON_PROD && (
                        <div className="outreach-settings-section">
                          <CustomLabel title="Outreach Settings" />
                          <Tooltip title="For use only in non prod env">
                            <span className="outreach-toggle-info">{MultiLanguageInfoIcon}</span>
                          </Tooltip>
                          <div className="outreach-toggle-row">
                            <Switch
                              checked={state.isTwilioDisabled}
                              onChange={handleTwilioDisabledToggle}
                              className="outreach-toggle-switch"
                            />
                            <span className="outreach-toggle-label">Disable Twilio</span>
                            <Tooltip title="Disables outbound Twilio messages for test scenarios.">
                              <span className="outreach-toggle-info">{MultiLanguageInfoIcon}</span>
                            </Tooltip>
                          </div>
                          <div className="outreach-toggle-row">
                            <Switch
                              checked={state.allowDuplicate}
                              onChange={handleAllowDuplicateToggle}
                              className="outreach-toggle-switch"
                            />
                            <span className="outreach-toggle-label">Allow Duplicate</span>
                            <Tooltip title="Allows duplicate records to be included during outreach.">
                              <span className="outreach-toggle-info">{MultiLanguageInfoIcon}</span>
                            </Tooltip>
                          </div>
                        </div>
                      )}
                    </div>
                    {state.delimiter === "commaSeparatedValues" ? (
                      <>
                        <Form className="direct-upload-form">
                          <section className="textarea-container">
                            <div className="textarea-and-label-container">
                              {" "}
                              <CustomLabel
                                title="Enter Values"
                                customClass="custom-label"
                              />
                              <div className="custom-textarea">
                                <DebouncedDirectTextInput
                                  validateForm={validateForm}
                                />
                              </div>
                            </div>
                            <CustomButton
                              htmlType="submit"
                              type="primary"
                              className={`custom-submit-button mt-16 ${
                                !isValid ? "disable-button" : ""
                              }`}
                              disabled={!isValid}
                              title="Create Broadcast"
                            />
                          </section>
                        </Form>
                      </>
                    ) : (
                      <section className="upload-file">
                        {!state.saveFileLayout ? (
                          <>
                            <>
                              <UploadFile
                                setFileData={setFile}
                                name="file"
                                handleRemove={handleResetFileData}
                                isReset={state.isReset}
                                fileFormat={
                                  state.delimiter === "comma"
                                    ? ["txt", "csv"]
                                    : "txt"
                                }
                                delimiter={state.delimiter}
                              />
                              <CustomButton
                                btntype="clear"
                                title="Recent Uploads"
                                className="recent-uploads"
                                onClick={handleRecentUploads}
                              />
                            </>
                          </>
                        ) : (
                          <div className="save-file-wrapper">
                            <div className="save-file-container">
                              <SaveFile
                                showConfirmPopup={showConfirmPopup}
                                getCustomeFileName={getCustomeFileName}
                                file={state.file}
                                responseError={state.fileNameError}
                                resetFileNameErr={resetFileNameErr}
                              />
                            </div>
                            <CustomButton
                              btntype="clear"
                              title="Back"
                              className="back-button"
                              onClick={handleBack}
                            />
                          </div>
                        )}
                      </section>
                    )}
                  </div>
                </Then>
                <Else>{""}</Else>
              </If>
              <If condition={selectFile && !fileUploaded}>
                <Then>
                  <div className="select-file-main-wrapper">
                    <div className="select-file-flex-wrapper">
                      <div className="select-file-container">
                        <SelectFile
                          handleUseCustomFile={handleUseCustomFile}
                          userType="employee"
                          handleLoading={handleLoading}
                          editDeleteAccess={props.editDeleteAccess}
                          changePreview={handlePreview}
                        />
                      </div>
                    </div>
                    <CustomButton
                      btntype="clear"
                      title={"Back"}
                      className="back-button"
                      onClick={handleBack}
                    />
                  </div>
                </Then>
                <Else>{""}</Else>
              </If>
            </div>

            {!fileUploaded &&
              state.delimiter !== "commaSeparatedValues" && (
                <div
                  className={`recent-uploads-mob ${
                    state.saveFileLayout ? "margin-top-8" : ""
                  }`}
                >
                  <div
                    className="select-file-main-wrapper"
                    testId="select-file-wrapper"
                  >
                    {!state.preview && (
                      <div className="recent-uploads-header">
                        Recent Uploads
                      </div>
                    )}
                    <div className="select-file-flex-wrapper">
                      <div className="select-file-container">
                        <SelectFile
                          handleUseCustomFile={handleUseCustomFile}
                          editDeleteAccess={editDeleteAccess}
                          userType="employee"
                          handleLoading={handleLoading}
                          changePreview={handlePreview}
                          handleMobFileSelect={handleMobFileSelect}
                          ref={selectFileRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            {!state.preview &&
              current === 0 && (
                <div className="bottom-bar">
                  <BottomBar
                    handleBackButton={backButtonClicked}
                    handleNextButton={() => {
                      handleNextButton(values);
                    }}
                    disabled={getDisabledState(isValid)}
                  />
                </div>
              )}
          </>
        );
      }}
    </Formik>
  );
};

const mapDispatchToProps = (dispatch) => ({
  uploadBroadCastFile: bindActionCreators(
    uploadBroadCastFileNewAction,
    dispatch
  ),
  uploadBroadCastCommaSeparatedValues: bindActionCreators(
    uploadBroadCastCommaSeparatedValuesAction,
    dispatch
  ),
  broadCastMessage: bindActionCreators(broadCastMessageAction, dispatch),
  reviewBroadCastMessage: bindActionCreators(
    broadCastMessageReviewAction,
    dispatch
  ),
  broadCastEmployeeList: bindActionCreators(
    broadCastEmployeeListAction,
    dispatch
  ),
  removeBroadCastEmployee: bindActionCreators(
    removeBroadCastEmployeeAction,
    dispatch
  ),
  setPopup: (data) => dispatch(setPopup(data)),
  noInternetAction: () => dispatch(NoInternetAction()),
});

const mapStateToProps = (state) => ({
  patients: state.patients,
  user: state.login.user,
  popupReducer: state.popupReducer,
  noInternet: state.noInternet,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EmployeeBroadcast)
);
